// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2Civ_","label":"Category_label__pFcJQ","content":"Category_content__3ATP6","header":"Category_header__37ywh","location":"Category_location__dPrKN"};